import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {ModelMapper} from './model-mapper';
import {User, UserModel} from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiService {
  protected readonly mapper = new ModelMapper(UserModel)

  // @ts-ignore
  override get() {
    return this.mapper.map(super.get<User>('user'))
  }
}
